module.exports = __webpack_public_path__ + "assets/templates/default-3fbf348d0fb6ae18fb730a598074ba24.mud";